/*
 * Copyright (c) 2026 Paxia AI Pty Ltd. All rights reserved.
 * This software is proprietary and confidential.
 * No part of this codebase may be copied, modified, published, distributed, sublicensed, or used without prior written permission from Paxia AI Pty Ltd.
 */

export function mergeLiveCandleIntoHistory(history, nextBar, previousLiveBar = null) {
  const previous = Array.isArray(history) ? history : [];
  const nextRealTime = nextBar?.time_real ?? nextBar?.time;
  if (!nextBar || !Number.isFinite(nextRealTime)) return previous;
  if (previous.length === 0) return [nextBar];

  const last = previous[previous.length - 1];
  const lastRealTime = last?.time_real ?? last?.time;
  if (!Number.isFinite(lastRealTime)) return [...previous, nextBar];
  if (nextRealTime < lastRealTime) return previous;
  if (nextRealTime === lastRealTime) return [...previous.slice(0, -1), { ...last, ...nextBar }];

  let finalized = previous;
  const previousLiveRealTime = previousLiveBar?.time_real ?? previousLiveBar?.time;
  if (previousLiveBar && previousLiveRealTime === lastRealTime) {
    finalized = [...previous.slice(0, -1), { ...last, ...previousLiveBar }];
  }
  return [...finalized, nextBar];
}
